import { defineMessages } from "react-intl";
const baseHttpCodesLocalization = defineMessages({
  401: {
    id: "MessageLocalizer_401",
    defaultMessage: "User is not authorized."
  },
  403: {
    id: "MessageLocalizer_403",
    defaultMessage: "User does not have the required permissions to perform an action."
  },
  404: {
    id: "MessageLocalizer_404",
    defaultMessage: "Record not found."
  },
  409: {
    id: "MessageLocalizer_409",
    defaultMessage: "Conflict during update."
  },
  500: {
    id: "MessageLocalizer_500",
    defaultMessage: "Unexpected error occurred."
  },
  502: {
    id: "MessageLocalizer_502",
    defaultMessage: "Service is not available."
  }
});
const defaultErrorLocalization = defineMessages({
  defaultErrorMessage: { id: "MessageLocalizer_defaultErrorMessage", defaultMessage: "OperationFailed." }
});
class MessageLocalizer {
  _codesLocalizations;
  _defaultErorr;
  constructor(localization = {}, defaultError = defaultErrorLocalization.defaultErrorMessage) {
    this._codesLocalizations = {
      ...baseHttpCodesLocalization,
      ...localization
    };
    this._defaultErorr = defaultError;
  }
  getMessageDescriptor(code) {
    return this._codesLocalizations[code] ?? this._defaultErorr;
  }
  isLocalizationExist(code) {
    return !!this._codesLocalizations[code];
  }
}
export {
  MessageLocalizer,
  baseHttpCodesLocalization,
  defaultErrorLocalization
};
//# sourceMappingURL=MessageLocalizer.js.map
